import * as React from "react";
import createSvgIcon from "./utils/create_svg_icon";

export default createSvgIcon(
  <path d="M 15 2 L 15 10 L 8 10 L 8 8 L 3 8 L 3 16 L 2 16 L 2 0 L 9 0 L 9 2 Z M 8 7 L 8 1 L 3 1 L 3 7 Z M 14 3 L 9 3 L 9 9 L 14 9 Z M 14 3 " />,
  "Flag",
);
